import React, { useEffect, useState } from 'react';
import { API, Auth } from 'aws-amplify';
import { AmplifyUser } from '@aws-amplify/ui';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ServerResponse } from 'http';
import { Http2ServerResponse } from 'http2';

type HomeProps = {
  activeLink: VoidFunction;
  user: AmplifyUser
};

type getOnOff = [{
  saggitaId: string,
  saggitaName: string,
  OnOff: string,
  recvDatetime: string,
  status: string,
  chgOnOff: string,
}];

type isSwitchType = [{
  saggitaId: string,
  checked: boolean,
  statusMsg: string
}];

type onOffSwitchItemType = {
  saggitaId: string,
  reqOnOff: string
}

type respDataType=[{
  saggitaId: string,
  errorNum: number
}]

const initOnoff = {
  saggitaId: "",
  saggitaName: "",
  OnOff: "",
  recvDatetime: "",
  status: "",
  chgOnOff: "",
};

const initIsSwitch = {
  saggitaId: "",
  checked: false,
  statusMsg: "",
};

const SaggitaOnOff: React.FC<HomeProps> = (props) => {
  const [onOffSaggita, setOnOffSaggita] = useState<getOnOff>([initOnoff]);
  const [isSwitch, setIsSwitch] = useState<isSwitchType>([initIsSwitch]);
  const [submitBtnDisable, setSubmitBtnDisable] = useState<boolean>(true);
  const [cancelBtnDisable, setCancelBtnDisable] = useState<boolean>(true);
  const [statusMsgClass, setStatusMsgClass] = useState<Array<string>>(["pt-3 m-0"]);

  const [alertText, setAlertText] = React.useState('');
  const [alertClass, setAlertClass] = React.useState('alert alert-danger d-none');
  const [failedAccount, setFailedAccount] = React.useState<Array<string>>([""]);


  props.activeLink();

  const userId = props.user.username;


  useEffect(() => {
    getSaggitaOnoffData();
  }, []);

  const setAlertMessage = (message: string) => {
    setAlertText(message);
    setAlertClass('alert alert-danger');
  };

  const setSuccessMessage = (message: string) => {
    setAlertText(message);
    setAlertClass('alert alert-success');
  };


  const createIsSwitch = (data: any) => {
    let isSwitchItemList = [];
    let statusMsgClassList = [];
    for (let val of data) {
      let statusMsg = "";
      let statusMsgClass = "pt-3 m-0 ";

      console.log('OnOff: ' + val.OnOff);

      if (val.status === "1") {
        statusMsg = val.statusDatetime
        statusMsg += val.chgOnOff === "1" ? " ON切替予定" : " OFF切替予定";
        statusMsgClass += val.chgOnOff === "1" ? "table-primary" : "table-danger";
      }

      if (val.OnOff === null) {
        statusMsg = "データなし";
      }

      let isSwitchItem = {
        saggitaId: val.saggitaId,
        checked: false,
        statusMsg: statusMsg
      };
      isSwitchItemList.push(isSwitchItem);
      statusMsgClassList.push(statusMsgClass);
    }
    setIsSwitch(isSwitchItemList as isSwitchType);
    setStatusMsgClass(statusMsgClassList);
  }

  const getSaggitaOnoffData = async () => {
    try {
      setSubmitBtnDisable(true);
      setCancelBtnDisable(true);

      const apiName = 'MainApi';
      const path = '/onoff/' + userId
      const myInit = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
      };

      const data = await API.get(apiName, path, myInit);

      setOnOffSaggita(data);
      createIsSwitch(data);

    } catch (err) {
      console.log(err);
      setAlertMessage('SO01001 データの取得に失敗しました。');
    }
  };

  const handleChangeButton = async (e: React.MouseEvent<HTMLInputElement>) => {
    try {
      let onOffSwitchItems: Array<onOffSwitchItemType> = [];
      isSwitch.forEach((data, index) => {
        if (data.checked && data.statusMsg === "") {
          const onOffSwitchItem = {
            saggitaId: data.saggitaId,
            reqOnOff: onOffSaggita[index].OnOff === "0" ? "1" : "0"
          };
          onOffSwitchItems.push(onOffSwitchItem as onOffSwitchItemType);
        }
      });

      const requestBody = {
        status: "1",
        onOffSwitchData: onOffSwitchItems
      };
      const apiName = 'MainApi';
      const path = '/onoff/' + userId;
      const myInit = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
        body: requestBody
      };
      const respData = await API.put(apiName, path, myInit) as respDataType;

      let failedAccount:Array<string>=[]
      respData.forEach((data, index) => {
        switch (data.errorNum) {
          case 1:
            failedAccount.push(data.saggitaId)
            setAlertMessage('SO01003 接点切り替えの処理に失敗しました。接点がすでに切り替わっていたため変更できませんでした。');
            break;
          case 3:
            failedAccount.push(data.saggitaId)
            setAlertMessage('SO01005 接点切り替えの処理に失敗しました。');
            break;
        }
      });
      if(failedAccount.length===0){
        setSuccessMessage("接点切替の登録が完了しました。");
      }
      else{
        setFailedAccount(failedAccount);
      }
    }
    catch (err) {
      console.log(err);
      setAlertMessage('SO01002 接点切り替えの処理に失敗しました。');
    }
    finally {
      getSaggitaOnoffData();
    }
  };

  const handleCancelButton = async (e: React.MouseEvent<HTMLInputElement>) => {
    try {
      let onOffSwitchItems: Array<onOffSwitchItemType> = [];
      isSwitch.forEach((data, index) => {
        if (data.checked && data.statusMsg !== "") {
          const onOffSwitchItem = {
            saggitaId: data.saggitaId,
            reqOnOff: onOffSaggita[index].OnOff
          };
          onOffSwitchItems.push(onOffSwitchItem as onOffSwitchItemType);
        }
      });

      const requestBody = {
        status: "0",
        onOffSwitchData: onOffSwitchItems
      };
      const apiName = 'MainApi';
      const path = '/onoff/' + userId;
      const myInit = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
        body: requestBody
      };
      const respData = await API.put(apiName, path, myInit) as respDataType;
      let failedAccount: Array<string> = []
      respData.forEach((data, index) => {
        switch (data.errorNum) {
          case 2:
            failedAccount.push(data.saggitaId)
            setAlertMessage('SO01004 接点切り替えの処理に失敗しました。接点がすでに切り替わっていたため変更できませんでした。');
            break;
          case 3:
            failedAccount.push(data.saggitaId)
            setAlertMessage('SO01005 接点切り替えの処理に失敗しました。');
            break;
        }
      });
      if (failedAccount.length === 0) {
        setSuccessMessage("接点切替の取消が完了しました。");
      }
      else {
        setFailedAccount(failedAccount);
      }
    }
    catch (err) {
      console.log(err);
      setAlertMessage('SO01002 接点切り替えの処理に失敗しました。');
    }
    finally {
      getSaggitaOnoffData();
    }
  };

  const handleChangeCheck = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let newIsSwitch = isSwitch.concat();
    newIsSwitch[index].checked = e.target.checked;
    setIsSwitch(newIsSwitch as isSwitchType);

    if (e.target.checked) {
      if (newIsSwitch[index].statusMsg === "") {
        setSubmitBtnDisable(false);
      }
      else {
        setCancelBtnDisable(false);
      }
    }
    else {
      let canselChackedList: Array<boolean> = [];
      let switchCheckedList:Array<boolean> = [];
      newIsSwitch.forEach((data, index) => {
        if (data.statusMsg === "") {
          switchCheckedList.push(data.checked)
        }
        else {
          canselChackedList.push(data.checked)
        }
      });
      if(!switchCheckedList.includes(true)){
        setSubmitBtnDisable(true);
      }
      if(!canselChackedList.includes(true)){
        setCancelBtnDisable(true);
      }
    }
  };

  const tableClass = 'pt-3 m-0';

  return (
    <div className="p-3">
      <div className={alertClass} role="alert">
        <h5 className="alert-heading">{alertText}</h5>
        {failedAccount}</div>
      <table className="table text-nowrap m-0 p-0" style={{ 'width': '800px' }}>
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">ID</th>
            <th scope="col">機体名称</th>
            <th scope="col">接点状態</th>
            <th scope="col">最終測定日時</th>
            <th scope="col">状況</th>
          </tr>
        </thead>
        <tbody>
          {
            onOffSaggita.map((data, index) => (
              <tr key={'tr-' + index}>
                <td className="form-check">
                  {(data.OnOff !== null) && (
                    <input className="form-check-input" type="checkbox" checked={isSwitch[index].checked} id={data.saggitaId + "chgOnOff"} onChange={(e) => handleChangeCheck(e, index)} />
                  )}
                </td>

                <td className={tableClass}>{data.saggitaId}</td>
                <td className={tableClass}>{data.saggitaName}</td>
                <td className={tableClass}>{data.OnOff === "1" ? "ON(接点短絡)" : (data.OnOff === "0" ? "OFF(接点開放)":"")}</td>
                <td className={tableClass}>{data.recvDatetime}</td>
                <td className={statusMsgClass[index]}>{isSwitch[index].statusMsg}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
      <div className='form-group m-0 p-0 '>
        <input type="button" className='btn btn-primary m-1' id="changeBtn" value='接点切替' onClick={(e) => handleChangeButton(e)} disabled={submitBtnDisable}></input>
        <input type="button" className='btn btn-danger m-1' id="cancelBtn" value='切替取消' onClick={(e) => handleCancelButton(e)} disabled={cancelBtnDisable}></input>
      </div>
    </div>
  );
}

export default SaggitaOnOff;
